import "../App.css";
import React from "react";

const SchedulePage = () => {
  return (
    <div>
      {/* <h1>Schedule Page</h1> */}
      <iframe
        title="schedule"
        src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FDenver&bgcolor=%23ffffff&showCalendars=0&showTz=0&mode=AGENDA&src=dmlwZXJiYXNrZXRiYWxsMjAyNEBnbWFpbC5jb20&color=%23039BE5"
        style={{ border: "solid 1px #777" }}
        width="95%"
        height="600"
        // frameborder="0"
        // scrolling="no"
      ></iframe>
    </div>
  );
};

export default SchedulePage;
